import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { IconsModule } from "@va/core-library/icons";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { AlertSettingsPageComponent } from "./alert-settings-page/alert-settings-page.component";
import { Routes, RouterModule } from "@angular/router";
import { SetAlertModalComponent } from "./set-alert-modal/set-alert-modal.component";
import { NzSelectModule } from "ng-zorro-antd/select";
import { AlertSettingsFilterPanelComponent } from "./alert-settings-filter-panel/alert-settings-filter-panel.component";
import { AlertSettingsGridWrapperComponent } from "./alert-settings-grid-wrapper/alert-settings-grid-wrapper.component";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { AntGridCustomModule } from "../ant-grid-custom/ant-grid-custom-module";
import { DataCellRenderersModule } from "../data-cell-renderers/data-cell-renderers.module";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzModalModule } from "ng-zorro-antd/modal";

const alertsRoutes: Routes = [
  {
    path: "",
    component: AlertSettingsPageComponent,
    data: {
      title: "Alerts Settings Page",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(alertsRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class AlertSettingsRoutingModule {}

@NgModule({
  declarations: [
    AlertSettingsPageComponent,
    SetAlertModalComponent,
    AlertSettingsFilterPanelComponent,
    AlertSettingsGridWrapperComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    AlertSettingsRoutingModule,
    IconsModule,
    NzSelectModule,
    SharedModule,
    NzRadioModule,
    NzToolTipModule,
    AntGridCustomModule,
    DataCellRenderersModule,
    ReactiveFormsModule,
    NzRadioModule,
    NzSelectModule,
    NzButtonModule,
    NzSkeletonModule,
    NzTableModule,
    NzModalModule,
  ],
})
export class AlertSettingsPageModule {}
